import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FinancialConnectionRefreshRequest } from './financial-connection-refresh-request.entity';

export class CreateFinancialConnectionRefreshRequestDto extends Omit(FinancialConnectionRefreshRequest, BaseEntityFieldsArray) {}
